import React from 'react';
import { CircularProgress } from '@mui/material';
import './Loading.css';


type LoadingProps = {
    text?: string;
}
const Loading: React.FC<LoadingProps> = ({text = 'データを読み込んでいます。'}) => {
    return (
        <div className="loading-container">
            <p>{ text }</p>
            <CircularProgress />
        </div>
    );
};

export default Loading;
